import { useSettingsStore } from '@/store';
import { ElementKey, RouteKey } from '@/types/config-types';

export const isPageAllowed = (
  key: string,
  allowedPages?: Record<string, boolean>
): boolean => {
  if (!allowedPages) return true;
  const allowed = allowedPages[key];
  return allowed === undefined || allowed === true;
};

export const usePermission = () => {
  const { settings } = useSettingsStore();
  const allowedElements = {
    ...settings?.ui?.pages_sections?.pages,
    ...settings?.ui?.pages_sections?.sections,
  };

  return (key: RouteKey | ElementKey) => isPageAllowed(key, allowedElements);
};
